import { Button as UiButton } from '@unlimitai/ui';
import classNames from 'classnames';
import type { HTMLProps, Ref } from 'react';
import { forwardRef } from 'react';

import styles from './index.module.scss';

export type Props = Omit<HTMLProps<HTMLButtonElement>, 'type' | 'size'>;

const IconButton = ({ children, className, ...rest }: Props, ref: Ref<HTMLButtonElement>) => {
  return (
    <UiButton
      ref={ref}
      variant="ghost"
      size="icon"
      type="button"
      className={classNames(styles.iconButton, className)}
      {...rest}
    >
      {children}
    </UiButton>
  );
};

export default forwardRef<HTMLButtonElement, Props>(IconButton);
